<div class="modal-content">
    <div class="modal-header">
        Change Contract Owner
        <button type="button" class="btn-close p-4" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="d-flex flex-column modal-body mb-0 pb-0">
        <p>Select a new owner for this contract</p>
        <app-form-field>
            <app-search required [minCharacters]="0" [searchFunction]="searchOrganisations" [inputFormatter]="refDataUtils.organisationFormatter"
                    dataKey="info.name" placeholder="Search for an organisation" class="w-100" [(ngModel)]="this.organisation"
                    (ngModelChange)="onTargetOrgChange($event)">
            </app-search>
        </app-form-field>
    </div>
    <div class="modal-footer justify-content-between">
        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
        <button type="button" class="btn btn-primary" [disabled]="!data?.contract?.contractId || !targetOrganisation?.organisationId"
                (click)="moveContract()" data-bs-dismiss="modal">
            Confirm
        </button>
    </div>
</div>
